import { CollectionWithCode } from '../../../api/public';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import { useTheme } from '@mui/material';
import CollectionCodeCard from './CollectionCodeCard';

interface CollectionCodeGridProps {
  collections: CollectionWithCode[];
}

const CollectionCodeGrid = ({ collections }: CollectionCodeGridProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        minHeight: '100vh',
        backgroundColor: '#FFFFFF',
        padding: spacing(3),
      }}
    >
      <DSBox
        sx={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <DSBox
          sx={{
            textAlign: 'center',
            marginBottom: spacing(4),
            paddingTop: spacing(2),
          }}
        >
          <DSTypography variant="h2" sx={{ color: '#000000' }}>
            Your Collection Codes
          </DSTypography>
          <DSTypography
            variant="body1"
            sx={{
              color: '#666666',
              marginTop: spacing(1),
            }}
          >
            Use these codes to add collections to your Klydoclock
          </DSTypography>
        </DSBox>

        <DSBox
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: spacing(3),
          }}
        >
          {collections.map((item, index) => (
            <DSBox
              key={index}
              sx={{
                width: {
                  xs: '100%',
                  sm: 'calc(50% - 12px)',
                  md: 'calc(33.333% - 16px)',
                },
                maxWidth: '350px',
              }}
            >
              <CollectionCodeCard
                collection={item.collection}
                code={item.code}
              />
            </DSBox>
          ))}
        </DSBox>
      </DSBox>
    </DSBox>
  );
};

export default CollectionCodeGrid;
